import { storage } from '../utils/storage';
import { auth } from '../config/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';

const API_KEY = 'AIzaSyDbknyG-fT-o7FRvemmjVxiID8g9n7QcYk';

interface LoginResponse {
  localId: string;
  email: string;
  displayName?: string;
  idToken: string;
  registered: boolean;
}

export const loginComRest = async (email: string, senha: string): Promise<LoginResponse> => {
  try {
    // Usar Firebase Auth SDK para autenticação (necessário para Cloud Functions)
    const userCredential = await signInWithEmailAndPassword(auth, email, senha);
    const user = userCredential.user;
    
    // Obter o token ID
    const idToken = await user.getIdToken();
    
    // Salva o token no localStorage (para compatibilidade)
    if (idToken) {
      await storage.setItem('authToken', idToken);
    }
    
    // Salvar refresh token se disponível
    if (user.refreshToken) {
      await storage.setItem('authRefreshToken', user.refreshToken);
    }

    return {
      localId: user.uid,
      email: user.email || email,
      displayName: user.displayName || undefined,
      idToken: idToken,
      registered: true,
    };
  } catch (error: any) {
    console.error('Erro no login:', error);
    
    // Se o erro for do Firebase Auth, traduzir mensagens
    let errorMessage = 'Erro ao fazer login';
    if (error.code === 'auth/user-not-found') {
      errorMessage = 'Usuário não encontrado';
    } else if (error.code === 'auth/wrong-password') {
      errorMessage = 'Senha incorreta';
    } else if (error.code === 'auth/invalid-email') {
      errorMessage = 'E-mail inválido';
    } else if (error.code === 'auth/user-disabled') {
      errorMessage = 'Usuário desabilitado';
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    throw new Error(errorMessage);
  }
};

